<template>
  <StaticFormHolder :form-name="formName" is-dialog :steps-before="stepsBefore" />
</template>

<script>
import phoneVerification from '@/mixins/phoneVerification';
import checkUserVerification from '@/mixins/checkUserVerification';
import userBenefitCurrentMutation from '@/mixins/currentMutation/userBenefitCurrentMutation';

export default {
  name: 'DashboardVideoTherapyForm',
  mixins: [phoneVerification, checkUserVerification, userBenefitCurrentMutation],
  data() {
    return {
      formName: 'videotherapy',
      isSending: false,
      loading: false
    };
  },
  computed: {
    stepsBefore() {
      return [
        {
          cmp: 'VideoTherapyInfoStep',
          dialogDataStore: 'staticForms/videoTherapy/infoStep'
        },
        {
          cmp: 'VideoTherapyFormStep',
          dialogDataStore: 'staticForms/videoCall/formStep',
          phoneVerificationInput: true
        },
        {
          cmp: 'VideoCallCalendar',
          dialogDataStore: 'staticForms/videoCall/iframeStep'
        },
        {
          cmp: 'VideoCallThankYou',
          dialogDataStore: 'staticForms/videoCall/thankYou'
        }
      ];
    },
    iframeLink() {
      return (
        this.currentMutation.videoCallLink +
        `?customerPrefill[firstname]=${encodeURIComponent(this.$auth.user.firstName)}&` +
        `customerPrefill[lastname]=${encodeURIComponent(this.$auth.user.lastName)}&` +
        `customerPrefill[email]=${encodeURIComponent(this.$auth.user.email)}&` +
        `customerPrefill[mobile]=${encodeURIComponent(this.$auth.user.phone)}&` +
        `customerPrefill[customFields][webuser_email]=${encodeURIComponent(
          this.$auth.user.email
        )}&` +
        `customerPrefill[customFields][partner_name]=${encodeURIComponent(
          this.partnerData.name
        )}&` +
        `customerPrefill[customFields][partner_id]=${this.partnerData.id}&` +
        `customerPrefill[customFields][partner_region]=${encodeURIComponent(
          this.partnerData.region
        )}`
      );
    }
  },
  created() {
    this.$store.dispatch('dynamicForms/setForm', {
      formName: this.formName,
      data: { formType: 'static' },
      stepsBefore: this.stepsBefore,
      updateRouteOnCreate: false
    });
  }
};
</script>
